'use client';

import { Fragment, type ReactNode, version } from 'react';
import { SSRProvider as RACSSRProvider } from 'react-aria-components';

export interface SSRProviderProps {
  /** The component tree that will be pre-rendered (usually the entire application). */
  children: ReactNode;
}

// react-aria's `SSRProvider` is required for React < 18
const hasNativeSSRSupport = Number(version.split('.')[0]) >= 18;
const BaseSSRProvider = hasNativeSSRSupport ? Fragment : RACSSRProvider;

/**
 * Allows Cimpress UI components to be pre-rendered on the server or at build time.
 *
 * See [server-side rendering guide](https://ui.cimpress.io/dev-guides/ssr/).
 */
export function SSRProvider({ children }: SSRProviderProps) {
  return <BaseSSRProvider>{children}</BaseSSRProvider>;
}

SSRProvider.displayName = 'SSRProvider';
